import { createApiRef } from "@backstage/core-plugin-api";
import type { ReleaseStatusClient } from "@internal/backstage-plugin-kubernetes-common";

/**
 * ApiRef for the Kubernetes release-status client.
 *
 * Backed by a {@link ReleaseStatusClient} that calls the deployments backend
 * module's aggregated release-status endpoint.
 *
 * @public
 */
export const releaseStatusApiRef = createApiRef<ReleaseStatusClient>({
    id: "plugin.k8s.release-status",
});
